import debounce from 'transmute/debounce';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UITextArea from 'UIComponents/input/UITextArea';
import SavableFormLabel from './SavableFormLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const onTextChange = debounce(500, (value, callback) => callback(value));

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message

function NotesTextArea(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SavableFormLabel, {
      "data-test-id": "notes-text-area-label",
      isSaving: props.isSaving,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.fields.notes.label"
      })
    }), /*#__PURE__*/_jsx(UITextArea, {
      "data-test-id": "notes-text-area-text-area",
      defaultValue: props.currentText,
      placeholder: I18n.text('app.escalations.fields.notes.placeholder'),
      rows: 4
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'EventTarg... Remove this comment to see the full error message
      ,
      onChange: ({
        target: {
          value
        }
      }) => onTextChange(value, props.onTextChange)
    })]
  });
}
NotesTextArea.propTypes = {
  currentText: PropTypes.string,
  isSaving: PropTypes.bool,
  onTextChange: PropTypes.func.isRequired
};
NotesTextArea.defaultProps = {
  currentText: '',
  isSaving: false
};
export default NotesTextArea;